var spoiler_default = {
  "fontElementMap": "k7Qoy",
  "hideText": "hr9WO",
  "onHoverText": "xrXt-",
  "hideBlock": "h80AC",
  "smallBlur": "NA0c-",
  "mediumBlur": "_73YPB",
  "largeBlur": "Q1yXD",
  "hideBlock_gallery": "_8ao6n",
  "overlay": "jQdcf",
  "overlay_gallery": "C2VD4",
  "revealSpoilerBtn": "hqhfP",
  "isMobile": "_1qG-N",
  "onHoverBtn": "aIQGG",
  "spoilerWrapper": "_8Jywd",
  "spoilerDescription": "-y4Qc",
  "spoilerContainer": "memiQ",
  "spoilerContainer_Gallery": "Mu3K4"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
